import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  Timestamp,
} from "firebase/firestore";
import { brand } from "@/constants/brandVariables/brandVariables";
import { Challenge } from "@/models/challenge.model";
import { useState, useEffect } from "react";

import { firestore } from "../api/firebaseConfig";

export const useGetLastFinishedChallenge = () => {
  const [data, setData] = useState<Challenge | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const challengesRef = collection(
      firestore,
      "challenges",
      brand.tenantId,
      "records",
    );

    const q = query(
      challengesRef,
      where("gameType", "==", brand.gameType),
      where("endDate", "<", Timestamp.now()),
      orderBy("endDate", "desc"),
      limit(1),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setData((snapshot.docs[0]?.data() as Challenge) ?? null);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching last finished challenge:", err);
        setError("Error fetching last finished challenge!");
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  return { data, loading, error };
};
